var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lead-flow-stage-marker ui-stage-marker",class:{
    'lead-flow-stage-marker--first': _vm.first, 'ui-stage-marker--first': _vm.first,
    'lead-flow-stage-marker--last': _vm.last, 'ui-stage-marker--last': _vm.last
  },attrs:{"aria-hidden":"true"}},[_c('span',{staticClass:"lead-flow-stage-marker__line ui-stage-marker__line"}),_c('span',{staticClass:"lead-flow-stage-marker__icon ui-stage-marker__icon"},[_c('img',{attrs:{"src":_vm.stageIcon,"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }